import { render, staticRenderFns } from "./WebLinkField.vue?vue&type=template&id=72ac5dfa&scoped=true"
import script from "./WebLinkField.vue?vue&type=script&lang=js"
export * from "./WebLinkField.vue?vue&type=script&lang=js"
import style0 from "./WebLinkField.vue?vue&type=style&index=0&id=72ac5dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac5dfa",
  null
  
)

export default component.exports